import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IFilialCompany, IListFilial } from '../../filiais/data/listcompany';

@Injectable({
  providedIn: 'root'
})
export class ListFilialService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Subsidiary`;

  constructor(private readonly toastService: ToastService, private readonly httpClient: HttpClient) {
    super(toastService);
  }

  getFilial(companyId?: string): Observable<ResponseDefault<IFilialCompany[]>> {
    let params = new HttpParams();

    if (companyId) {
      params = params.append('companyId', companyId);
    }

    return this.httpClient.get<ResponseDefault<IFilialCompany[]>>(`${this.apiUrl}/ListActive`, { params });
  }
}
